var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"space-y-8"},[_c('linked-in-login-card',{attrs:{"header":"Connect to a LinkedIn page","hide-copy-button":"","bot-id":_vm.bot.id,"page-id":_vm.bot.platformData.linkedIn._id},on:{"connect":_vm.onConnect,"disconnect":_vm.onDisconnect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }